import { createApp, ref, reactive, onMounted } from 'vue'

const app = createApp({
  setup() {
    const checkBoxStatement = reactive([])
    const alertStatement = ref(false)
    onMounted(() => {
      let checkBoxArray = document.querySelectorAll('.c-check-box')
      for (let i = 0; i < checkBoxArray.length; i++) {
        // console.log(checkBoxArray[i].checked)
        if (checkBoxArray[i].checked) {
          checkBoxStatement[i] = true
        } else {
          checkBoxStatement[i] = false
        }
      }
    })
    const checkBoxChange = (event, number) => {
      let checkBoxArray = document.querySelectorAll('.c-check-box')
      for (let i = 0; i < checkBoxArray.length; i++) {
        // console.log(checkBoxArray[i].checked)
        if (checkBoxArray[i].checked) {
          checkBoxStatement[i] = true
        } else {
          checkBoxStatement[i] = false
        }
      }
      if (event.target.checked) {
        checkBoxStatement[number] = true
      } else {
        checkBoxStatement[number] = false
      }
      if (checkBoxStatement.filter((item) => item === true).length !== 1) {
        alertStatement.value = true
      } else {
        alertStatement.value = false
      }
      // console.log(checkBoxStatement)
      // console.log(checkBoxStatement.filter((item) => item === true).length)
      // console.log(alertStatement.value)
    }
    return { checkBoxStatement, alertStatement, checkBoxChange }
  }
})

if (document.querySelector('#boardControl')) {
  app.mount('#boardControl')
}
